import { useState, useEffect } from 'react';
import { totalCountEvent } from 'services/generalServices';
import { listLeadStages } from 'services/Settings';
import { extractPracticeAreaIds } from 'utils/utils';

export default function useLeadStages(practiceAreaIds = [], loadFullList = true, limit = 15, inputValue = '') {
  const [leadStages, setLeadStages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [nextToken, setNextToken] = useState('');

  const loadLeadStages = async (
    practiceAreaIds = [],
    limit = 15,
    pagination_token = '',
    pagination_direction = 'forward',
    inputValue = ''
  ) => {
    setIsLoading(true);

    let pageLimit = limit;
    if (loadFullList) {
      const response = await totalCountEvent('lead-stage');
      pageLimit = response?.data;
    }
    try {
      const response = await listLeadStages(
        pageLimit,
        pagination_token,
        pagination_direction,
        'ACTIVE',
        { practice_area: extractPracticeAreaIds(practiceAreaIds), show_unassigned_pa_column: true },
        '',
        inputValue
      );
      setLeadStages(response?.data?.lead_stage || []);
      return response?.data;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    loadLeadStages(practiceAreaIds, limit, '', 'forward', inputValue);
  }, []);

  return { leadStages, isLeadStageLoading: isLoading, loadLeadStages, leadStageToken: nextToken };
}
